// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video_wrapper__3bCil","player":"Video_player__21pFq"};